

export function titleCase(title) {
  return title && title
    .toLowerCase()
    .replace(/((^|[\s(])\w)/g,
      v => v.toUpperCase());
}

export function formatArtistName(writer) {
  return writer &&
    writer
      .split(',')
      .reverse()
      .map(v => v.trim())
      .join(' ')
      .toLowerCase()
      .replace(/((^|[\s(])\w)/g, v => v.toUpperCase());
}
